import React from 'react';
import { autotranslateText, isNotEmpty } from '../../lib/ep';
import { injectIntl } from 'react-intl';

import ConfirmButton from './ConfirmButton';
import OpenInNewTabIcon from './OpenInNewTabIcon';

const TypeButton = ({ children, ...props }) => {
	return (
		<button {...props}>
			{children}
		</button>
	)
};

const TypeLink = ({ children, ...props }) => {
	return (
		<a {...props}>
			{children}
		</a>
	)
};

const TypeSpan = ({ children, ...props }) => {
	return (
		<span {...props}>
			{children}
		</span>
	)
};

export const ThesaurusLink = (props) => {
	if(props.tooltip == undefined) {
		// Tooltip is mandatory in a ThesaurusLink
		return (
			<ActionLink
				{...props}
			/>
		)
	}

	return (
		<ActionLink
			{...props}
			is_thesaurus={true}
		/>
	)
};

function selectAllText(element) {
	var doc = document;
	var text = doc.getElementById(element);
	var range, selection;

	if(doc.body.createTextRange) {
		range = document.body.createTextRange();
		range.moveToElementText(text);
		range.select();
	} else if (window.getSelection) {
		selection = window.getSelection();
		range = document.createRange();
		range.selectNodeContents(text);
		selection.removeAllRanges();
		selection.addRange(range);
	}
}

const ActionLink = (props) => {
	const fullclass = props?._fullclass ?? false;
	const _id = props?._id ?? null;
	const target = props?._target ?? '_self';
	const href = props?._href ?? null;
	const downloadable = props?.download ?? false;
	const select_this = props?.select_this ?? false;
	const disabled = props?.disabled ?? false;
	const icon = props?.icon ?? false;
	let classname = props?.classname ?? '';
	const _nofollow = props?._nofollow ?? null;
	const is_thesaurus = props?.is_thesaurus ?? false;

	const onclick = (e) => {
		if(disabled) return;

		if(props.stopPropagation) e.stopPropagation();

		if(props.onClick != undefined) {
			props.onClick(e);
			e.preventDefault();
		} else if(select_this && href == undefined && _id != undefined) {
			selectAllText(_id);
		}
	}

	let classes = classname.split(" ");

	let inTop = true;
	let isSubmit = true;

	if(disabled) classes.push('disabledItem');

	if(fullclass === false) {
		if(props._class) {
			for(var i in props._class) {
				if(i == 'icon_off') continue;

				switch(i) {
					case 'in_top':
						inTop = props._class[i];
						break;

					case 'submit':
						isSubmit = props._class[i];
						break;

					default:
						classes.push(props._class[i]);
						break;
				}
			}
		}
	} else {
		classname = fullclass;
		classes = classname.split(" ");
	}

	if(is_thesaurus) {
		classes.push('thesaurus_link in_top');
	} else {
		if(isSubmit) classes.push('submit_link');
		if(icon) classes.push(icon);
		if(inTop) classes.push('in_top');
	}

	let datas = {};
	if(props.data_attr != undefined) {
		for(let i in props.data_attr) {
			datas[i] = props.data_attr[i];
		}
	}

	const type_confirm = ((props?.type ?? 'link') == 'confirm') ? true : false;
	if(type_confirm) {
		return (
			<ConfirmButton
				{...props}
				type="link"
			/>
		)
	}

	const Component = (!is_thesaurus) ? ((true || isNotEmpty(props, '_href')) ? TypeLink : TypeButton) : TypeSpan;

	const item_props = {
		id:_id,
		className:classes.filter((i) => (i != "" && i != " ")).join(" "),
		style:props.style,
		onMouseEnter:props.onMouseEnter,
		onMouseLeave:props.onMouseLeave,
		onMouseDown:props.onMouseDown,
		onMouseUp:props.onMouseUp,
		...datas,
	};

	if(!is_thesaurus) {
		item_props.rel = _nofollow;
		item_props.href = href;
		item_props.download = downloadable;
		item_props.onClick = onclick;
	}

	if(href != undefined) {
		item_props.target = target;
	}

	return (
		<Component {...item_props}>
			{autotranslateText(props.children, props.autotranslate, props.intl)}

			{(props?.display_open_in_new_tab ?? false) && (
				<OpenInNewTabIcon />
			)}

			{(props.tooltip != undefined) && (
				props.tooltip
			)}
		</Component>
	);
}

export default injectIntl(ActionLink);